
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'OxygenDeliveryMethodAndConcentration',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/OxygenDeliveryMethodAndConcentration.vue